/**
 * Component to render eligibility criteria tab data in EE how to nominate page
 */
const EligibilityCriteria = (): React.ReactElement => {
  return (
    <div data-testid="eligibility-criteria-component">
      <p>
        The application form must be accompanied by financial statements for the
        last two financial years† and the business must fulfil the following
        criteria:
      </p>

      <div className="mb-5 bg-gray-150 p-4 font-medium">
        <p className="mb-0 font-bold">Years of business operation</p>

        <p>
          Up to 10 years (Up to 3 years of business operations for Most
          Promising Startup Award and Most Promising Sustainability Startup
          Award)
        </p>

        <p className="mb-0 font-bold">Business incorporation</p>

        <p>
          Registered either as a Sole Proprietor, Partnership, Limited
          Partnership, Limited Liability Partnership, or Private Limited. Not
          applicable to listed company, lending institution or the lender&apos;s
          affiliates.
        </p>

        <p>
          Note: For Indonesia: Registered either as a Limited Liability Company
          (Perseroan Terbatas or PT) or Limited Liability Partnership
          (Commanditaire Vennonntschap or CV)
        </p>

        <p className="mb-0 font-bold">Local Shareholding</p>

        <p>At least 30%</p>

        <p className="mb-0 font-bold">
          Annual sales turnover as of the last financial year
        </p>

        <p>Up to S$20 million or local currency equivalent</p>

        <p className="mb-0 font-bold">Business profile</p>

        <p>Must be a registered business.</p>

        <p className="mb-0">For example:</p>

        <ul className="mb-4 list-outside list-disc pl-8">
          <li>
            Singapore: Business profile with Accounting and Corporate Regulatory
            Authority (ACRA)
          </li>
          <li>
            Malaysia: Business profile with Companies Commission of Malaysia
            (CCM) or Suruhanjaya Syarikat Malaysia (SSM)
          </li>
          <li>
            Indonesia: Company Registration Certificate (TDP) or NIB or Trading
            Business License (SIUP) or similar document
          </li>
          <li>
            Hong Kong: Certificate of Incorporation or Business Registration
            Certificate
          </li>
        </ul>

        <p className="mb-0 font-bold">
          Financial documentation must be provided
        </p>

        <p>
          Latest financial statements for the last two financial years,
          including management statements.
        </p>

        <p className="mt-18">
          †For businesses that have only 1 year of operation, financial
          statements can be for the prior or current year, whichever is
          available.
        </p>
      </div>
    </div>
  );
};

export default EligibilityCriteria;
